import _toConsumableArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { Stage, Layer, Circle } from "react-konva";
import { timeToAngle } from "./utils";
import { ClockFace } from "./ClockFace";
import { HeatRange } from "./HeatRange";
import { ClockPoint } from "./ClockPoint";
import { useMedia } from "../../utils/useMedia";

function extractPumpTime() {
  var pumpTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "0:0";

  var _pumpTime$split = pumpTime.split(":"),
      _pumpTime$split2 = _slicedToArray(_pumpTime$split, 2),
      dayOfWeekStr = _pumpTime$split2[0],
      minutesOfDayStr = _pumpTime$split2[1];

  return [+dayOfWeekStr, +minutesOfDayStr];
}

var getNowTime = function getNowTime() {
  var now = new Date();
  var hours = now.getHours();
  var minutes = now.getMinutes();
  var minutesOfDay = hours * 60 + Math.floor(minutes / 30) * 30;
  return minutesOfDay;
};

var getPosition = function getPosition(ranges, now) {
  var result = {
    before: false,
    inside: false,
    outside: false,
    index: 0
  };

  for (var index = 0; index < ranges.length; index++) {
    var _ranges$index = _slicedToArray(ranges[index], 2),
        from = _ranges$index[0],
        to = _ranges$index[1];

    if (now <= to) {
      return _objectSpread(_objectSpread({}, result), {}, {
        before: now < from,
        inside: now >= from,
        index: index
      });
    }
  }

  return _objectSpread(_objectSpread({}, result), {}, {
    outside: true
  });
};

var getRanges = function getRanges(heatSchedule, circleState, minutesOfDay, dayOfWeek) {
  var endOfDay = 24 * 60;

  if (circleState === "DISABLED") {
    return [];
  }

  if (circleState === "FILLED") {
    return [[0, endOfDay]];
  }

  var ranges = heatSchedule[dayOfWeek];

  if (circleState === "DEFAULT") {
    return ranges;
  }

  var lastIndex = ranges.length - 1;
  var position = getPosition(ranges, minutesOfDay);

  if (position.before) {
    return ranges.map(function (range, index) {
      return index === position.index ? [minutesOfDay, range[1]] : range;
    });
  }

  if (position.inside && position.index === lastIndex) {
    return ranges.map(function (range, index) {
      return index === lastIndex ? [range[0], endOfDay] : range;
    });
  }

  if (position.inside) {
    var patched = ranges.map(function (range, index) {
      return index === position.index ? [range[0], ranges[index + 1][1]] : range;
    });
    patched.splice(position.index + 1, 1);
    return patched;
  }

  return [].concat(_toConsumableArray(ranges), [[minutesOfDay, endOfDay]]);
};

var getPastRange = function getPastRange(circleState, nowAngle) {
  if (circleState === "DISABLED") {
    return [0, 360];
  }

  if (circleState === "FILLED") {
    return undefined;
  }

  return [0, nowAngle];
};

var getCircleState = function getCircleState(heatConfig, heatMode, error) {
  var manual = heatConfig.manual,
      forced = heatConfig.forced,
      vacation = heatConfig.vacation;

  if (error || manual && !vacation) {
    return "FILLED";
  }

  if (forced === "AWAY" || vacation || heatMode === "VACATION") {
    return "DISABLED";
  }

  if (!forced) {
    return "DEFAULT";
  }

  return "FORCED";
};

export function ScheduleIndicator(_ref) {
  var heatConfig = _ref.heatConfig,
      heatMode = _ref.heatMode,
      pumpTime = _ref.pumpTime,
      error = _ref.error;
  var isSmall = useMedia(["(max-width: 420px)"]);

  var _extractPumpTime = extractPumpTime(pumpTime),
      _extractPumpTime2 = _slicedToArray(_extractPumpTime, 2),
      dayOfWeek = _extractPumpTime2[0],
      minutesOfDay = _extractPumpTime2[1];

  var now = getNowTime();
  var circleState = getCircleState(heatConfig, heatMode, error);
  var ranges = getRanges(heatConfig.heatSchedule, circleState, minutesOfDay, dayOfWeek);
  var angleRanges = ranges.map(function (range) {
    return range.map(timeToAngle);
  });
  var displayNow = circleState !== "FILLED" && circleState !== "DISABLED";
  var disabled = circleState === "DISABLED";
  var nowAngle = timeToAngle(minutesOfDay);
  var pastRange = getPastRange(circleState, nowAngle);
  var SIZE = isSmall ? 288 : 368;
  var RADIUS = isSmall ? 130 : 170;
  var OFFSET = -SIZE / 2;
  return /*#__PURE__*/React.createElement(Stage, {
    width: SIZE,
    height: SIZE,
    offsetX: OFFSET,
    offsetY: OFFSET,
    listening: false
  }, /*#__PURE__*/React.createElement(Layer, null, /*#__PURE__*/React.createElement(ClockFace, {
    clockRadius: RADIUS,
    inactiveRange: pastRange
  })), /*#__PURE__*/React.createElement(Layer, {
    rotation: -90
  }, !disabled && angleRanges.map(function (range) {
    return /*#__PURE__*/React.createElement(HeatRange, {
      key: range[0],
      range: range,
      clockRadius: RADIUS,
      nowAngle: displayNow ? nowAngle : undefined
    });
  }), displayNow && /*#__PURE__*/React.createElement(ClockPoint, {
    as: Circle,
    angle: nowAngle,
    fill: "#333",
    clockRadius: RADIUS,
    radius: 7
  })));
}